import { Services } from "../../ServiceLocator";
import { postData } from "../Api/Actions";
import { calculatePrice, receiveConfiguration, setConfigurationChanged } from "../Configuration/Actions";
import { setWorkInProgress } from "../Ui/Actions";
import omit from "lodash/omit";

export const ADD_FIELD = "ARTUS_ADD_FIELD";
export const REMOVE_FIELD = "ARTUS_REMOVE_FIELD";
export const UPDATE_FIELD = "ARTUS_UPDATE_FIELD";
export const UPDATE_LAYER = "ARTUS_UPDATE_LAYER";
export const UPDATE_GLOBAL_PARAMETER = "ARTUS_UPDATE_GLOBAL_PARAMETER";
export const RECEIVE_ARTUS_CONFIGURATION = "ARTUS_RECEIVE_ARTUS_CONFIGURATION";
export const SET_HIDE_TOP_VIEW = "ARTUS_SET_HIDE_TOP_VIEW";

export const addNewField = () => (dispatch) => {
  dispatch({
    type: ADD_FIELD,
  });
  dispatch(calculatePrice());
  dispatch(setConfigurationChanged(true));
};

export const removeField = (fieldId) => async (dispatch) => {
  await dispatch({
    type: REMOVE_FIELD,
    fieldId,
  });
  dispatch(calculatePrice());
  dispatch(setConfigurationChanged(true));
  return dispatch(updateOverallWidth());
};

export const updateField = (fieldId, key, value) => (dispatch, getState) => {
  const { artusIdentifierAttributeValueMap } = getState().Configuration;

  dispatch({
    type: UPDATE_FIELD,
    artusIdentifierAttributeValueMap,
    fieldId,
    key,
    value,
  });
  dispatch(setConfigurationChanged(true));
  dispatch(calculatePrice());
};

export const updateLayer = (fieldId, layerId, key, value) => (dispatch) => {
  dispatch({
    type: UPDATE_LAYER,
    fieldId,
    layerId,
    key,
    value,
  });
  dispatch(setConfigurationChanged(true));
  dispatch(calculatePrice());
};

export const updateGlobalParameter = (key, value) => (dispatch) => {
  dispatch({
    type: UPDATE_GLOBAL_PARAMETER,
    key,
    value,
  });
  if (key !== "scaleFactor" && key !== "overallWidth") {
    dispatch(calculatePrice());
    dispatch(setConfigurationChanged(true));
  }
};

export const setArtus = (data) => (dispatch) => {
  dispatch({
    type: RECEIVE_ARTUS_CONFIGURATION,
    data,
  });
};

export const saveArtusConfiguration = (configurationtype = "", screenshot) => (dispatch, getState) => {
  const { configuration } = getState().Configuration;
  const artus = omit(getState().Artus, "shelfLoadRules");
  const configurationWithArtus = {
    ...configuration,
    code: configurationtype === 'cart' ? configuration.code : null,
    customdata: { ...configuration.customdata, artus },
    screenshots: screenshot,
  };
  return dispatch(
    postData(
      "frontendapi/configurations",
      {
        configuration: configurationWithArtus,
        configurationtype,
      },
      receiveConfiguration
    )
  ).then((result) => {
    if (configurationtype === "print") {
      Services.store.dispatch(setWorkInProgress("pdfDownload", false));
    } else {
      Services.store.dispatch(setWorkInProgress("saveConfiguration", false));
    }
    return result;
  });
};

export const updateOverallWidth = () => (dispatch, getState) => {
  const { fields } = getState().Artus;
  const { artusIdentifierAttributeValueMap } = getState().Configuration;
  let overallWidth = 0;
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];
    const nextField = i !== fields.length - 1 ? fields[i + 1] : fields[i];
    const fieldWidth = Number(field.width.match(/\d+/));
    const currentLeftFrameWidth = Number(artusIdentifierAttributeValueMap.get(`${field.height}_frameWidth`));
    let currentRightFrameWidth = Number(
      artusIdentifierAttributeValueMap.get(`${nextField.height}_frameWidth`)
    );
    if (currentRightFrameWidth < currentLeftFrameWidth) {
      currentRightFrameWidth = currentLeftFrameWidth;
    }
    overallWidth +=
      field.id === 1
        ? fieldWidth + currentLeftFrameWidth + currentRightFrameWidth
        : fieldWidth + currentRightFrameWidth;
  }

  dispatch(updateGlobalParameter("overallWidth", overallWidth));
};

export const setHideTopView = (hide) => (dispatch) => {
  return dispatch({
    type: SET_HIDE_TOP_VIEW,
    hide,
  });
};
